export default function GallerySection() {
  return null;
}
